import Polyline from './Polyline';

export default Polyline;
